/**
 * Created by AlexanderC on 5/27/15.
 */

/*eslint no-eq-null: 0, eqeqeq:0 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Statement = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Resource = require('./Resource');

var _Collection = require('./Collection');

var _Action = require('./Action');

var _Policy = require('./Policy');

var _Extractable2 = require('./Extractable');

var _InvalidArgumentException = require('../../Exception/InvalidArgumentException');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * IAM policy statement
 */
let Statement = exports.Statement = function (_Extractable) {
  _inherits(Statement, _Extractable);

  function Statement() {
    _classCallCheck(this, Statement);

    var _this = _possibleConstructorReturn(this, (Statement.__proto__ || Object.getPrototypeOf(Statement)).call(this));

    _this._effect = Statement.ALLOW;
    _this._action = new _Collection.Collection(_Action.Action);
    _this._notAction = new _Collection.Collection(_Action.Action);
    _this._resource = new _Collection.Collection(_Resource.Resource);
    _this._notResource = new _Collection.Collection(_Resource.Resource);
    _this._condition = null;
    _this._principal = null;
    return _this;
  }

  /**
   * @param {String} effect
   */


  _createClass(Statement, [{
    key: 'extract',


    /**
     * @returns {Object}
     */
    value: function extract() {
      let actions = this._action.count() > 0 ? this._action.extract() : _Policy.Policy.ANY;
      let resources = this._resource.count() > 0 ? this._resource.extract() : null;

      let statement = {
        Effect: this._effect,
        Action: actions
      };

      if (resources !== null) {
        statement.Resource = resources;
      }

      if (this._condition !== null && this._condition instanceof Object) {
        statement.Condition = this._condition;
      }

      // @todo - create separate class for Principal
      if (this._principal != null) {
        statement.Principal = this._principal;
      }

      if (this._notAction.count() > 0) {
        statement.NotAction = this._notAction.extract();
      }

      if (this._notResource.count() > 0) {
        statement.NotResource = this._notResource.extract();
      }

      return statement;
    }
  }, {
    key: 'effect',
    set: function set(effect) {
      if ([Statement.ALLOW, Statement.DENY].indexOf(effect) === -1) {
        throw new _InvalidArgumentException.InvalidArgumentException(effect, '[Statement.ALLOW, Statement.DENY]');
      }

      this._effect = effect;
    }

    /**
     * @returns {String}
     */
    ,
    get: function get() {
      return this._effect;
    }

    /**
     * @param {Object} condition
     */

  }, {
    key: 'condition',
    set: function set(condition) {
      this._condition = condition;
    }

    /**
     * @returns {Object}
     */
    ,
    get: function get() {
      return this._condition;
    }

    /**
     * @param {*} principal
     */

  }, {
    key: 'principal',
    set: function set(principal) {
      this._principal = principal;
    }

    /**
     * @returns {*}
     */
    ,
    get: function get() {
      return this._principal;
    }

    /**
     * @returns {Collection}
     */

  }, {
    key: 'notResource',
    get: function get() {
      return this._notResource;
    }

    /**
     * @returns {Collection}
     */

  }, {
    key: 'resource',
    get: function get() {
      return this._resource;
    }

    /**
     * @returns {Collection}
     */

  }, {
    key: 'notAction',
    get: function get() {
      return this._notAction;
    }

    /**
     * @returns {Collection}
     */

  }, {
    key: 'action',
    get: function get() {
      return this._action;
    }

    /**
     * @returns {String}
     */

  }], [{
    key: 'ALLOW',
    get: function get() {
      return 'Allow';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'DENY',
    get: function get() {
      return 'Deny';
    }
  }]);

  return Statement;
}(_Extractable2.Extractable);


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/IAM/Statement.js
// module id = 163
// module chunks = 0